import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
        <FaqSection />
        <IndexSection />
        <CardsSection />
        <AboutSection />
        <ContactSection />
        <UpdatesSection />
        <FeaturesSection />
        <CarouselSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}